import { Select } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

function SortBy({ value, onChange, rightContentRef }) {
  const { t } = useTranslation();

  const sortingOptions = [
    { label: t('relevanceAsc'), value: '' },
    { label: t('priceLowToHigh'), value: 'price:ASC' },
    { label: t('priceHighToLow'), value: 'price:DESC' }
  ];

  const selectedValue = sortingOptions.find(o => o.value === value || '');

  return (
    <S.SortByWrapper>
      <S.SortByText className="label">{t('sortBy')}:</S.SortByText>
      <Select
        placeholder={selectedValue.label || t('sortBy')}
        onChange={data => {
          onChange(data);
        }}
        value={selectedValue}
        options={sortingOptions}
        size="sm"
        simple
        styles={{
          menu: () => ({
            right: '0',
            left: '0'
          })
        }}
        menuPortalTarget={rightContentRef.current}
      />
    </S.SortByWrapper>
  );
}

export { SortBy };
